/**
 * ACC_BN_LP_103 — Section 12: FAQ Accordion
 *
 * Simple, reliable slide up/down using JS-driven max-height.
 * Each <details> item opens/closes independently. On open we render the
 * content, animate max-height 0 -> content height, then release to "none"
 * so it can reflow. On close we pin the current height, animate to 0, and
 * remove the `open` attribute when the transition finishes.
 * aria-expanded is kept in sync for screen readers.
 */
(function () {
  'use strict';

  function initItem(details) {
    if (details.__acc103Bound) return;
    details.__acc103Bound = true;

    var summary = details.querySelector('.acc103-12__question');
    var wrap = details.querySelector('.acc103-12__answer-wrap');
    if (!summary || !wrap) return;

    // Initial state (items may render with the `open` attribute).
    if (details.open) {
      details.classList.add('is-open');
      wrap.style.maxHeight = 'none';
      summary.setAttribute('aria-expanded', 'true');
    } else {
      wrap.style.maxHeight = '0px';
      summary.setAttribute('aria-expanded', 'false');
    }

    function openItem() {
      details.open = true;
      details.classList.add('is-open');
      summary.setAttribute('aria-expanded', 'true');
      wrap.style.maxHeight = wrap.scrollHeight + 'px';
      var onEnd = function (ev) {
        if (ev.target !== wrap || ev.propertyName !== 'max-height') return;
        wrap.removeEventListener('transitionend', onEnd);
        if (details.classList.contains('is-open')) wrap.style.maxHeight = 'none';
      };
      wrap.addEventListener('transitionend', onEnd);
    }

    function closeItem() {
      // Pin the current height, then animate to 0 on the next frame.
      wrap.style.maxHeight = wrap.scrollHeight + 'px';
      void wrap.offsetHeight; // force reflow so the transition runs
      details.classList.remove('is-open');
      summary.setAttribute('aria-expanded', 'false');
      requestAnimationFrame(function () { wrap.style.maxHeight = '0px'; });
      var onEnd = function (ev) {
        if (ev.target !== wrap || ev.propertyName !== 'max-height') return;
        wrap.removeEventListener('transitionend', onEnd);
        if (!details.classList.contains('is-open')) details.open = false;
      };
      wrap.addEventListener('transitionend', onEnd);
    }

    summary.addEventListener('click', function (e) {
      e.preventDefault();
      if (details.open) closeItem(); else openItem();
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('.acc103-12__item').forEach(initItem);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Shopify theme editor live-reload
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) init(e.target);
  });
})();
